
import { Component, Vue, Prop } from 'vue-property-decorator';

import FormList from "./components/FormList.vue"

import { stepInfoType } from "@/types/Application";
import PageBase from "../PageBase.vue";

import moment from 'moment-timezone';
import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase,
        GetHelpForPdf,
        FormList
    }
})

export default class ReviewAndPrint extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    // @applicationState.State
    // public requiredDocuments!: string[];

    @applicationState.Action
    public UpdateGotoPrevStepPage!: () => void

    @applicationState.Action
    public UpdateGotoNextStepPage!: () => void

    @applicationState.State
    public generatedForms!: string[];

    error= "";
    currentStep=0;
    currentPage=0;
    
    showPDFpreview = false;

    showGetHelpForPDF = false;
    applicationLocation = {name:'', address:'', cityStatePostcode:'', email:''}
    requiredDocuments: string[] = [];

    formsList = [];

    mounted(){

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
       
        let location = this.$store.state.Application.applicationLocation
        if(!location) location = this.$store.state.Common.userLocation
        //console.log(location)

        if(location == 'Victoria'){
            this.applicationLocation = {name:'Victoria Law Courts', address:'850 Burdett Avenue', cityStatePostcode:'Victoria, B.C.  V8W 9J2', email:'Victoria.CourtScheduling@gov.bc.ca'}
        }else if(location == 'Surrey'){
            this.applicationLocation = {name:'Surrey Provincial Court', address:'14340 - 57 Avenue', cityStatePostcode:'Surrey, B.C.  V3X 1B2', email:'CSBSurreyProvincialCourt.FamilyRegistry@gov.bc.ca'}
        }  
        
        this.requiredDocuments = [];
        this.requiredDocuments = Vue.filter('extractRequiredDocuments')(this.getRepGrantResultData())

    }

    public onPrev() {
        this.UpdateGotoPrevStepPage()
    }

    public onNext() {
        this.UpdateGotoNextStepPage()     
    }

    public setFormList(formsList){
        this.formsList = formsList
    }

    public isFormReviewed(){
        for(const form of this.formsList)
            if(!this.generatedForms.includes(form.name)){
                //console.log(form)
                return false
            }
        return true
    }

    public checkErrorOnPages(){

        const optionalLabels = ["Next Steps", "Review and Print", "Review and Save", "Review and Submit"]

        for(const step of this.$store.state.Application.steps){
            if(step.active){
                for(const page of step.pages){
                    if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                        this.$store.commit("Application/setCurrentStep", step.id);
                        this.$store.commit("Application/setCurrentStepPage", {currentStep: step.id, currentPage: page.key });
                        const nextChildGroup = document.getElementById(this.getStepGroupId(step.id));
                        //const currPage = document.getElementById(this.getStepPageId(step.id, page.key));
                        //console.log(nextChildGroup)
                        // if(nextChildGroup){
                        //     if(Number(step.id)==8){
                        //         nextChildGroup.style.display = "none";
                        //         Vue.nextTick(()=>nextChildGroup.style.display = "block")
                        //     }else{
                        //         nextChildGroup.style.display = "block";
                        //     }
                        // }
                        //if(currPage){currPage.style.color="red";}
                        return false;
                    }
                }
            }            
        }
        return true;        
    }

    public getStepId(stepIndex) {
        return "step-" + stepIndex;
    }

    public getStepGroupId(stepIndex) {
        return this.getStepId(stepIndex) + "-group";
    }

    public getStepPageId(stepIndex, pageIndex) {
        return this.getStepId(stepIndex) + "-page-" + pageIndex;
    }

    public loadPdf() {
        const applicationId = this.$store.state.Application.id;
        const url = '/survey-print/'+applicationId+'/?name=application-about-a-protection-order'
        const body = this.getRepGrantResultData()
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        //console.log(body)
        this.$http.post(url,body, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = "fpo.pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);
            this.error = "";
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);
        },err => {
            console.error(err);
            this.error = "Sorry, we were unable to print your form at this time, please try again later.";
        });

    }
    
    public onPrint() {
        
        const el= document.getElementById("print");
        console.log(el)
        const applicationId = this.$store.state.Application.id;
        
        const url = '/survey-print/'+applicationId+'/?name=application-about-a-protection-order'
        const body = Vue.filter('printPdf')(el.innerHTML,`"SCCRPF  02/2021 \a         Form P1";`)
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  
        console.log(body)
        this.$http.post(url,body, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = "FormP1.pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);            
        },err => {
            console.error(err);
        
        });
    }

    public getRepGrantResultData() {  
        
        var result = this.$store.state.Application.steps[0].result; 
        for(var i=1;i<9; i++){
            const stepResults = this.$store.state.Application.steps[i].result
            for(const stepResult in stepResults){
                console.log(stepResults[stepResult])
                console.log(stepResults[stepResult].data)
                result[stepResult]=stepResults[stepResult].data; 
                //Object.assign(result, result,{$stepResult: stepResults[stepResult].data});  
            }
        }
            //Object.assign(result, result, this.$store.state.Application.steps[i].result); 
            
        //Object.assign(result, result,{yourInformationSurvey: this.$store.state.Application.steps[1].result.yourInformationSurvey.data}); 
        
        var deceasedDateOfDeath = {deceasedDateOfDeath: this.$store.state.Application.deceasedDateOfDeath}
        Object.assign(result, result, deceasedDateOfDeath);
        
        var applicationLocation = this.$store.state.Application.applicationLocation;
        var userLocation = this.$store.state.Common.userLocation;
        //console.log(applicationLocation)
        //console.log(userLocation)
        if(applicationLocation)
            Object.assign(result, result,{applicationLocation: applicationLocation}); 
        else
            Object.assign(result, result,{applicationLocation: userLocation});
        console.log(result)
        return result;
    }

    // beforeDestroy() {
    //     Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);
    // }

}
